// extracted by mini-css-extract-plugin
export default {"loading-indicator":"loading-indicator--Wn4p7","loadingIndicator":"loading-indicator--Wn4p7","slide-right":"slide-right--W0WhN","slideRight":"slide-right--W0WhN"};